<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer032">
<div id="_idContainer071">
<div class="photo" id="_idContainer000"><img alt="" class="img50" src="Images/titlepage.jpg"/></div>
<p class="firstcenter"><a href="http://www.ivpress.com/books" target="_blank"><img alt="" class="img50" src="Images/1.png"/></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?7677bfbc